import React, { Fragment, useContext, useState } from 'react';
import Sidebar from '../../../layouts/global/dashboard/Sidebar';
import TopHeader from '../../../layouts/global/dashboard/TopHeader';
import AllGroups from '../../../layouts/dashboard/AllGroups';
import { Redirect } from 'react-router';
import { AuthContext } from '../../../contexts/AuthContext';
import { BeneficiaryContext } from '../../../contexts/BeneficiaryContext';
import CreateGroup from '../../../layouts/dashboard/CreateGroup';
import GroupCard from '../../../layouts/dashboard/GroupCard';
import LoadingSpinner from '../../../components/LoadingSpinner';
import PageTitle from '../../../layouts/global/dashboard/PageTitle';

export default function Beneficiaries() {
  const { state } = useContext(AuthContext);
  const [viewModal, setViewModal] = useState(false);
  const openModal = () => setViewModal(true);
  const closeModal = () => setViewModal(false);
  const { groups, loading } = useContext(BeneficiaryContext);

  return (
    <Fragment>
      {state.isAuth ? (
        <Redirect to="/dashboard/beneficiaries" />
      ) : (
        <Redirect to="/login" />
      )}
      <CreateGroup viewModal={viewModal} closeModal={closeModal} />
      <main className={'flex flex-col lg:flex-row'}>
        <Sidebar />
        <TopHeader />
        <section className={'w-full bg-gray-100 min-h-screen'}>
          <div
            className={
              'w-full px-5 lg:pl-72 pt-20 lg:pt-16 lg:pr-10 bg-gray-100'
            }
          >
            <PageTitle title={'Beneficiaries'} />
            <div
              style={{ minHeight: 500 }}
              className={'shadow p-5 bg-white w-full'}
            >
              <div
                className={
                  'mb-3 flex flex-col lg:flex-row lg:justify-between lg:items-center'
                }
              >
                <h3 className={'text-lg font-medium'}>All Groups</h3>

                <div
                  className={'mt-3 lg:mt-0 flex justify-between items-center'}
                >
                  <button
                    onClick={openModal}
                    className={
                      'border-2 border-yellow-500 bg-yellow-500 shadow rounded-sm px-2 lg:px-3 py-1 lg:py-2  lg:text-sm lg:mr-2'
                    }
                  >
                    <span className={'ml-1'}>Create group</span>
                  </button>
                  <a
                    href="/Beneficiaries.xlsx"
                    className={
                      'border-2 border-yellow-500 shadow rounded-sm px-2 lg:px-3 py-1 lg:py-2  lg:text-sm'
                    }
                  >
                    Download Excel Template
                  </a>
                </div>
              </div>
              <div>
                <p className={'text-yellow-500'}>
                  <i className={'fas fa-exclamation-circle'} /> Download the
                  Excel template and edit to create a group
                </p>
              </div>
              <AllGroups>
                {loading ? (
                  <LoadingSpinner color={'text-yellow-500'} />
                ) : groups.length > 0 ? (
                  groups.map((item, index) => (
                    <GroupCard key={index} item={item} />
                  ))
                ) : null}
              </AllGroups>
            </div>
          </div>
        </section>
      </main>
    </Fragment>
  );
}
